import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams, Link, NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HeadingCp from '../components/HeadingCp';
import DevicesAccordion from '../components/DevicesAccordion';
import { Menu, MenuButton, MenuItem, MenuItems, Select } from '@headlessui/react';
import { EllipsisVerticalIcon } from '@heroicons/react/20/solid';
import { TrashIcon } from '@heroicons/react/24/outline';
import SelectParts from '../components/SelectParts';
import { Nav } from 'react-bootstrap';
import { fi } from 'date-fns/locale';

const EsBuilder = () => {
  const apiUrl = process.env.REACT_APP_API_URL;   // e.g. "http://localhost/api"
  const navigate = useNavigate();
  const { id } = useParams();  // can be 'list' or a numeric string
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('estimate');
  const [laborCategories, setLaborCategories] = useState([]);
  const [loadingGlobal, setLoadingGlobal] = useState(false);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [savingGlobal, setSavingGlobal] = useState(false);
  const [savingCategories, setSavingCategories] = useState(false);
  const [selectedCategoryOption, setSelectedCategoryOption] = useState('');

  const [deleteTemplate, setDeleteTemplate] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  
  const [activeEstimate, setActiveEstimate] = useState(null);
  const [showIssuesModal, setShowIssuesModal] = useState(false);

  const [servicePart, setServicePart] = useState({ part: '', quantity: 1 });
  const [parts, setParts] = useState([]);
  const [selectParts, setSelectedParts] = useState(null);  

  // For the "Add Device" form ---- new update
const [showDeviceModal, setShowDeviceModal] = useState(false);
const [deviceSearch, setDeviceSearch] = useState('');
const [deviceResults, setDeviceResults] = useState([]);
const [selectedDeviceIds, setSelectedDeviceIds] = useState([]);
const [savingDevices, setSavingDevices] = useState(false);

   // For listing existing notes
  const [notes, setNotes] = useState([]);

  // For the new note form
  const [newNote, setNewNote] = useState({
    key_order: '',
    notes: '',
    cat: ''
  });

  // For listing existing services
  const [services, setServices] = useState([]);

  // For the new service form
  const [newService, setNewService] = useState({
    name: '',
    price: '',
    cat: '',
    is_active: 1
  });

  // ========== 1) Global Settings State ==========
  const [fees, setFees] = useState({
    job_mark_up: '',
    discount: '',
    tarif_rate: '',
    tax_rate: '',
    as_built: '',
    paf_price: ''
  });

  // Helper function to switch tabs
  const handleTabClick = (tab) => {   
    setActiveTab(tab);
  };

  // Controls whether the "New Estimate" modal is open
  const [showCreateModal, setShowCreateModal] = useState(false);

  // A blank object for creating a new estimate (no ID)
  const blankEstimate = {
    id: '',
    estimate_type: '',
    estimate_name: '',
    user_name: '',
    full_description: '',
    type: ''
  };

  const [newLabor, setNewLabor] = useState({
    name: '',
    rate: '0.00',
    min_hours: '0.00',
    is_active: 1
  });


  // ---------------------------
  // 1) List vs. Single Estimate
  // ---------------------------
  const [estList, setEstList] = useState([]);
  const [singleEst, setSingleEst] = useState({
    id: '',
    estimate_type: '',
    estimate_name: '',
    user_name: '',
    full_description: '',
    type: '',
    manufacture: ''
  });

  // Decide if we are in "list mode" or "edit mode" based on the param
  const isListMode = (id === 'list');

  // ---------------------------
  // 2) Equipment Categories
  // ---------------------------
  const [equipmentCategories, setEquipmentCategories] = useState([]);
  // Form state for creating a new equipment category
  const [newCategory, setNewCategory] = useState({
    equipment_category: ''
  });

  // ---------------------------
  // 3) Equipment/Devices
  // ---------------------------
  // Each category can have multiple devices, so we’ll store them inside `equipmentCategories`.
  // Alternatively, we could store them in a single separate state, but let's keep it simple.

  // Form state for adding a new device to a particular category
  const [newDevice, setNewDevice] = useState({
    categoryId: '',
    device_name: '',
    full_description: '',
    sub_category: '',
    device_price: ''
  });

  // Right after your other useState declarations
  const [activeCategoryId, setActiveCategoryId] = useState(null);


  // ----------------------------------
  // FETCH: All data needed in edit mode
  // ----------------------------------
  useEffect(() => {
    fetchData(id);
  }, [apiUrl, id, isListMode, navigate]);

  useEffect(() => {
    if (equipmentCategories.length > 0 && activeCategoryId === null) {
      setActiveCategoryId(equipmentCategories[0].id);
    }
  }, [equipmentCategories, activeCategoryId]);


  const fetchData = async () => {
    try {
      setLoading(true);
      if (isListMode) {
        // 1) List all estimates
        const response = await axios.get(`${apiUrl}/es_builder_crud.php?id=list`, {
          headers: { 'Content-Type': 'application/json' }
        });
        if (response.data[0] === 'success') {
          setEstList(response.data[1] || []);
        } else {
          toast.error(response.data.error || 'Failed fetching list.', {
            position: 'top-center',
          });
        }
      } else {
        const responseEst = await axios.get(`${apiUrl}/es_builder_crud.php?id=${id}`, {
          headers: { 'Content-Type': 'application/json' }
        });
        if (responseEst.data[0] === 'success' && responseEst.data[1].length > 0) {
          const estData = responseEst.data[1][0];
          setSingleEst({
            id: estData.id,
            estimate_type: estData.estimate_type,
            estimate_name: estData.estimate_name,
            user_name: estData.user_name,
            full_description: estData.full_description,
            type: estData.type,
            manufacture: estData.manufacture
          });
        } else {
          navigate('/es_builder/list');
          // toast.error(responseEst.data.error || 'No data found for this ID.', {
          //   position: 'top-center',
          // });
        }

        // 2b) Get categories for this estimate
        const responseCats = await axios.get(`${apiUrl}/es_builder_crud.php?equipment=${id}`, {
          headers: { 'Content-Type': 'application/json' }
        });
        if (responseCats.data[0] === 'success') {
          setEquipmentCategories(responseCats.data[1] || []);
        } else {
          // toast.error(responseCats.data.error || 'Failed fetching categories.', {
          //   position: 'top-center',
          // });
        }

        // 2c) get Labor categories for this estimate
        const laborCategories = await axios.get(`${apiUrl}/es_builder_crud.php?getLaborCategories=${id}`, {
          headers: { 'Content-Type': 'application/json' }
        });
        if (laborCategories.data[0] === 'success') {
          setLaborCategories(laborCategories.data[1] || []);
        } else {
          // toast.error(laborCategories.data.error || 'Failed fetching categories.', {
          //   position: 'top-center',
          // });
        }

        // 2d) Fetch notes for this estimate
        const notesResponse = await axios.get(`${apiUrl}/es_builder_crud.php?getNotes=true&&es_builder_estimate_id=${id}`, {
          headers: { 'Content-Type': 'application/json' }
        });
        // Expecting something like ["success", [{id, key_order, notes, cat}, ...]]
        if (notesResponse.data[0] === 'success') {
          setNotes(notesResponse.data[1]);
        } else {
          // toast.error(notesResponse.data[1] || 'No notes found.', { position: 'top-center' });
        }      

        // 2d) Fetch service for this estimate
        const serviceResponse = await axios.get(`${apiUrl}/es_builder_crud.php?services=true&&es_builder_estimate_id=${id}`, {
          headers: { 'Content-Type': 'application/json' }
        });
        // Expecting ["success", [{ id, name, price, cat, is_active }, ...]] or an empty array
        if (serviceResponse.data[0] === 'success') {
          setServices(serviceResponse.data[1]);
        } else {
          // toast.error(serviceResponse.data[1] || 'No services found.', { position: 'top-center' });
        }               

        // 2e) Fetch Fees for this estimate
        const feesResponse = await axios.get(`${apiUrl}/es_builder_crud.php?fees=true&&es_builder_estimate_id=${id}`, {
          headers: { 'Content-Type': 'application/json' }
        });
        // Expecting ["success", { job_mark_up, discount, tarif_rate, tax_rate, as_built, paf_price }]
        if (feesResponse.data[0] === 'success') {
          // If it exists, setFees with the returned object
          setFees(feesResponse.data[1] || {});
        } else {
          // Possibly no row found, or an error
          toast.error(feesResponse.data[1] || 'No fees found.', { position: 'top-center' });
        }              

      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        navigate('/login');
      } else if (error.response && error.response.status === 403) {
        toast.error("Oops!! you don't have access to this area.", { position: 'top-center' });
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  // ----------------------------------
  // 1) List Mode Rendering
  // ----------------------------------

  const handleDeleteIssues = (issues) => {
    console.log(issues, 'issues');
    setActiveEstimate(issues);
    setShowIssuesModal(true);
  }

  const okIssues = () => {
    setShowIssuesModal(false);
    setActiveEstimate(null);
  };

  const handleDeleteClick = (template) => {
    setDeleteTemplate(template);
    setShowConfirmModal(true);
  };  
    
  const cancelDelete = () => {
    setShowConfirmModal(false);
    setDeleteTemplate(null);
  };

  const handleDeleteTemplate = async () => {
    // e.preventDefault();
     if (!deleteTemplate) return;

    setLoading(true);
      const bodyData = {
        builder_id: deleteTemplate.id,
        status: 'DeleteTemplate',
      };
      try {
        const response = await axios.post(`${apiUrl}/es_builder_crud.php`, bodyData, {
          headers: { 'Content-Type': 'application/json' },
        });
        console.log('Response:', response.data); // Log the response for debugging
        
        if (response.data.success) {
          toast.success('successfully deleted template!', {
            position: 'top-center',
          });
            setShowConfirmModal(false);
            setDeleteTemplate(null);
            fetchData('list');
        } else {
          toast.error(response.data.error || 'Failed to save', {
            position: 'top-center',
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error('You do not have permission to edit this template.', {
            position: 'top-center',
          });
          navigate('/login');
        }
      } finally {
        setLoading(false);
      }
  };

  const onDuplicate = async (row) => {
    // e.preventDefault();
    
    setLoading(true);
      const bodyData = {
        builder_id: row,
        status: 'DuplicateEstimate',
      };
      try {
        const response = await axios.post(`${apiUrl}/es_builder_crud.php`, bodyData, {
          headers: { 'Content-Type': 'application/json' },
        });
        console.log('Response:', response.data); // Log the response for debugging
        
        if (response.data.success) {
          toast.success('successfully saved!', {
            position: 'top-center',
          });
          fetchData('list');
        } else {
          toast.error(response.data.error || 'Failed to save', {
            position: 'top-center',
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          toast.error('You do not have permission to edit this template.', {
            position: 'top-center',
          });
          navigate('/login');
        }
      } finally {
        setLoading(false);
      }
  };

  const renderAllEstimates = () => {
    return (
      <div>
        {/* New Estimate button */}
        <div className="flex justify-end mb-4 gap-2">
          <button
            className="px-4 py-2 bg-green-600 text-white font-semibold rounded"
            onClick={() => {
              // Reset singleEst to blank so the form is empty
              setSingleEst(blankEstimate);
              // Show the modal
              setShowCreateModal(true);
            }}
          >
            New Template
          </button>
          <NavLink to="/equipment_list">
          <button
            className="px-4 py-2 bg-blue-600 text-white font-semibold rounded">
            Equipment Library
          </button>
          </NavLink>
        </div>

        {/* The current list */}
        <ul role="list" className="divide-y divide-gray-100">
          {estList.map((project) => (
            <li
              key={project.id}
              className="flex items-center justify-between gap-x-6 py-5"
            >
              <div className="min-w-0">
                <div className="flex items-start gap-x-3">
                  <p className="text-sm font-semibold text-gray-900">
                    {project.estimate_name}
                  </p>
                </div>
                <div className="mt-1 flex items-center gap-x-2 text-xs text-gray-500">
                  <p className="whitespace-nowrap">{project.full_description}</p>
                  <svg viewBox="0 0 2 2" className="size-0.5 fill-current">
                    <circle r={1} cx={1} cy={1} />
                  </svg>
                  <p className="truncate">Created by {project.user_name}</p>
                </div>
              </div>          
              <div className="flex flex-none items-center gap-x-4">
                <a
                  href={`${project.id}`}
                  className="hidden rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold 
                    text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 
                    hover:bg-gray-50 sm:block"
                >
                  Edit<span className="sr-only">, {project.estimate_name}</span>
                </a>
                
               <button onClick={() => onDuplicate(project.id)}
                   className="hidden rounded-md bg-blue-600 px-2.5 py-1.5 text-sm font-semibold 
                    text-white shadow-sm ring-1 ring-inset ring-gray-300 
                    hover:bg-blue-300 sm:block"
                title="Duplicate this template">
                Duplicate
              </button>    
            {Array.isArray(project.es_system) && project.es_system.length > 0 ? (
               <button
                onClick={() => handleDeleteIssues(project.es_system)}
                   className="hidden rounded-md bg-gray-600 px-2.5 py-1.5 text-sm font-semibold 
                    text-white shadow-sm ring-1 ring-inset ring-gray-300 
                    hover:bg-gray-300 sm:block"
                title="Duplicate this template">
                X
              </button> 
            ) : (
              <button
                onClick={() => handleDeleteClick(project)}
                className="hidden rounded-md bg-red-600 px-2.5 py-1.5 text-sm font-semibold
                    text-white shadow-sm ring-1 ring-inset ring-gray-300
                    hover:bg-red-300 sm:block"
                title="Delete this template">
                X
              </button>
            )}   
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  // ----------------------------------
  // 2) Single Estimate Edit
  // ----------------------------------
  // A) Basic Info: Estimate form
  const handleEstimateChange = (e) => {
    const { name, value } = e.target;
    setSingleEst((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEstimateSubmit = async (e) => {
    e.preventDefault();

    // If singleEst.id is empty => create; else => update
    const isNew = !singleEst.id;

    const bodyData = {
      // Possibly a 'status' field to tell your backend what's happening
      status: 'EsBuilderUpdate',
      estimate_id: singleEst.id || '',
      estimate_type: singleEst.estimate_type,
      estimate_name: singleEst.estimate_name,
      user_name: singleEst.user_name,
      full_description: singleEst.full_description,
      type: singleEst.type,
      manufacture: singleEst.manufacture,
    };

    try {
      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      console.log(response.data, 'response for estimate submit');
      if (response.data.success) {
        toast.success(isNew ? 'Estimate created successfully!' : 'Estimate updated!', {
          position: 'top-center'
        });

        if (isNew) {
          // The backend should return the newly created estimate ID
          const newId = response.data[0]; 
          // Hide the modal
          setShowCreateModal(false);
          // Redirect to the new estimate page. 
          // e.g. /estimate/newId or /es_builder/newId, adjust as needed
          navigate(`/es_builder/${newId}`);
        } else {
          // If it's an update, maybe stay on this page or refresh
          // ...
        }
      } else {
        toast.error(response.data.error || 'Failed updating.', { position: 'top-center' });
      }
    } catch (error) {
      // ...
    }
  };


  // ----------------------------------
  // Equipment Category
  // ----------------------------------
  // B) Equipment Category change
  const handleCategoryChange = (e) => {
    const { name, value } = e.target;
    setNewCategory((prev) => ({
      ...prev,
      [name]: value
    }));
  };
// B) Equipment Category submit
  const handleCategorySubmit = async (e) => {
    e.preventDefault();
    if (!newCategory.equipment_category) {
      toast.error('Please enter a category name.', { position: 'top-center' });
      return;
    }
    // Insert new category into DB
    const bodyData = {
      status: 'EsBuilderEquipmentCatAdd',
      es_builder_estimate_id: singleEst.id,
      equipment_category: newCategory.equipment_category
    };
    
     console.log(bodyData, 'bodyData');
    try {
      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      console.log(response.data);
      
      if (response.data.success) {
        toast.success('Category added successfully!', { position: 'top-center' });
        // Clear the form
        setNewCategory({ equipment_category: '' });
        fetchData(singleEst.id);
      } else {
        toast.error(response.data.error || 'Failed adding category.(verify duplicate)', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error while adding category.', { position: 'top-center' });
    }
  };
// B) Equipment Category delete
  const handleDeleteEquipmentCat = async (e, categoryId) => {
    e.preventDefault();
    if (!categoryId) {
      toast.error('No category ID found.', { position: 'top-center' });
      return;
    }
    const bodyData = {
      status: 'EsBuilderEquipmentDelete',
      equipment_category_id: categoryId
    };
    try {
      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data.success) {
        toast.success('Category deleted successfully!', { position: 'top-center' });
        // Refresh categories
        fetchData(singleEst.id);
      } else {
        toast.error(response.data.error || 'Failed deleting category.', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error while deleting category.', { position: 'top-center' });
    }
  }

  const handleCategorySelect = (e) => {
    const chosen = e.target.value;
    setSelectedCategoryOption(chosen);
    
    // If they pick one of the known categories (not 'Other'), 
    // set that category immediately
    if (chosen !== 'Other') {
      setNewCategory({ equipment_category: chosen });
    } else {
      // If 'Other', clear out the text so user can type
      setNewCategory({ equipment_category: '' });
    }
  }; 

  // ----------------------------------
  // C) Equipment Category Devices
  // ----------------------------------
  // C) Devices change
  const handleDeviceChange = (e) => {
    const { name, value } = e.target;
    setNewDevice((prev) => ({
      ...prev,
      [name]: value
    }));
  };
  // C) Devices Submit
  const handleDeviceSubmit = async () => {
        // setLoading(true);
    console.log(selectParts, 'selectParts');
    // e.preventDefault();
    // Must have a categoryId, device_name, etc.
    if (!newDevice.categoryId || !selectParts.part) {
      toast.error('Please select a category and enter a device name.', { position: 'top-center' });
      return;
    }
    const bodyData = {
      status: 'esBuilderAddDevice',
      es_builder_equipment_cat_id: newDevice.categoryId,
      equipment_list_id: selectParts.id,
      // full_description: selectParts.description,
      // sub_category: selectParts.sub_category,
      // device_price: selectParts.device_price,
    };
    try {
      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      console.log(response.data, 'response for device submit');
      
      if (response.data.success) {
        toast.success('Device added successfully!', { position: 'top-center' });
        // Clear form
        setNewDevice({
          categoryId: '',
          device_name: '',
          full_description: '',
          sub_category: '',
          device_price: '',
          equipment_list_id : ''
        });
        
         setSelectedParts('');
        
        // Refresh categories & devices
        const refresh = await axios.get(`${apiUrl}/es_builder_crud.php?status=getCategories&estimate_id=${singleEst.id}`, {
          headers: { 'Content-Type': 'application/json' }
        });
        if (refresh.data[0] === 'success') {
          setEquipmentCategories(refresh.data[1] || []);
        }
        fetchData(singleEst.id);
      } else {
        toast.error(response.data.error || 'Failed adding device.', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error while adding device.', { position: 'top-center' });
    }
  };
  // C) Devices delete
  const handleDeleteDevice = async (e, categoryId) => {
    e.preventDefault();
    if (!categoryId) {
      toast.error('No category ID found.', { position: 'top-center' });
      return;
    }
    const bodyData = {
      status: 'EsBuilderEquipmentDelete',
      equipment_category_id: categoryId
    };
    try {
      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      if (response.data.success) {
        toast.success('Category deleted successfully!', { position: 'top-center' });
        // Refresh categories
        fetchData(singleEst.id);
      } else {
        toast.error(response.data.error || 'Failed deleting category.', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error while deleting category.', { position: 'top-center' });
    }
  }
  //C) Handle Category Tab Click
  const handleCatTabClick = (categoryId) => {
    setActiveCategoryId(categoryId);
    console.log(activeCategoryId, 'clicked on tab');
  };  

  const handlePartSelect = newPart => {
    console.log(newPart, 'newPart');
    
    if (newPart && newPart.part) {
      setSelectedParts(newPart);
      setParts(prev => ({
        ...prev,
        part: newPart.part,
        id: newPart.id
      }));
      
    } else {
      //console.error('Invalid company selected:', newCompany);
    }
  };


  // ----------------------------------
  // D) Labor 
  // ----------------------------------
  // D) For the categories table
  const handleCategoryFieldChange = (catId, field, newValue) => {
    setLaborCategories((prevCats) =>
      prevCats.map((cat) =>
        cat.id === catId ? { ...cat, [field]: newValue } : cat
      )
    );
  };
  // D) Save Categories (all at once)
  const handleSaveCategories = async () => {
    setSavingCategories(true);
    try {
      // We'll send the entire categories array to the back end:
      // Ex: [ {id, rate, min_hours, is_active}, ... ]
      const bodyData = {
        status: 'laborCategoriesUpdate',
        data: laborCategories.map((cat) => ({
          id: cat.id,
          es_builder_estimate_id: cat.es_builder_estimate_id,
          name: cat.name,
          rate: cat.rate,
          min_hours: cat.min_hours,
          is_active: cat.is_active
        }))
      };
      console.log(bodyData, 'bodyData for labor categories');
      
      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      console.log(response.data, 'response for labor categories');
      
      if (response.data.success) {
        toast.success('Categories saved!', { position: 'top-center' });
      } else {
        toast.success('Categories saved!', { position: 'top-center' });
        // toast.error(response.data.error || 'Failed to save categories.', {
        //   position: 'top-center'
        // });
      }
    } catch (err) {
      toast.error('Error saving categories.', {
        position: 'top-center'
      });
    } finally {
      setSavingCategories(false);
    }
  };
  // D) add labor
  const handleAddLabor = async (e) => {
    e.preventDefault();

    try {
      const bodyData = {
        status: 'addLabor',
        es_builder_estimate_id: singleEst.id,
        name: newLabor.name,
        rate: newLabor.rate,
        min_hours: newLabor.min_hours,
        is_active: newLabor.is_active,
      };

      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });

      if (response.data.success) {
        // The backend should return the new record's ID
        const dbId = response.data.new_id; 
        // Add to local state
        const newItem = {
          id: dbId,
          name: newLabor.name,
          rate: parseFloat(newLabor.rate),
          min_hours: parseFloat(newLabor.min_hours),
          is_active: newLabor.is_active,
        };
        setLaborCategories([...laborCategories, newItem]);
        // Reset
        setNewLabor({ name: '', rate: '0.00', min_hours: '0.00', is_active: 1 });
      } else {
        toast.error(response.data.error || 'Failed to add labor.', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error while adding labor.', { position: 'top-center' });
    }
  };
  // D) delete labor
  const handleDeleteCat = async (laborId) => {
  // setLaborCategories(laborCategories.filter((cat) => cat.id !== id));
    // if (!window.confirm('Are you sure you want to delete this labor?')) return;
    try {
      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, {
        status: 'deleteLabor',
        labor_id: laborId
      });

      if (response.data.success) {
        toast.success('Labor deleted!', { position: 'top-center' });
        // Filter out the deleted labor from the state
        setLaborCategories(laborCategories.filter((l) => l.id !== laborId));
      } else {
        toast.error(response.data.error || 'Failed to delete labor.', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error while deleting labor.', { position: 'top-center' });
    }
  };

  // ----------------------------------
  // E) Notes
  // ----------------------------------
  const handleAddNote = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!newNote.notes) {
      toast.error('Please enter a note.', { position: 'top-center' });
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, {
        status: 'addNote',
        es_builder_estimate_id: singleEst.id,
        key_order: newNote.key_order,
        notes: newNote.notes,
        cat: newNote.cat
      });

      if (response.data.success) {
        toast.success('Note added!', { position: 'top-center' });
        // Clear form
        setNewNote({
          key_order: '',
          notes: '',
          cat: ''
        });
        // Re-fetch notes
        fetchData(singleEst.id);
      } else {
        toast.error(response.data.error || 'Failed to add note.', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error while adding note.', { position: 'top-center' });
    }
  };

  const handleDeleteNote = async (noteId) => {
    // if (!window.confirm('Are you sure you want to delete this note?')) return;

    try {
      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, {
        status: 'deleteNote',
        note_id: noteId
      });
      console.log(response.data, noteId, 'response for delete note');
      
      if (response.data.success) {
        toast.success('Note deleted!', { position: 'top-center' });
        // Filter out the deleted note from the state
        setNotes(notes.filter((n) => n.id !== noteId));
      } else {
        toast.error(response.data.error || 'Failed to delete note.', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error while deleting note.', { position: 'top-center' });
    }
  };
  

  // ----------------------------------
  // F) Services
  // ----------------------------------
  const handleAddService = async (e) => {
    e.preventDefault();

    // Basic validation
    if (!newService.name) {
      toast.error('Please enter a service name.', { position: 'top-center' });
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, {
        status: 'addService',
        es_builder_estimate_id: singleEst.id,
        name: newService.name,
        price: newService.price,
        cat: newService.cat,
        is_active: newService.is_active
      });

      if (response.data.success) {
        toast.success('Service added!', { position: 'top-center' });
        // Clear form
        setNewService({ name: '', price: '', cat: '', is_active: 1 });
        // Re-fetch services
        fetchData(singleEst.id);
      } else {
        toast.error(response.data.error || 'Failed to add service.', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error while adding service.', { position: 'top-center' });
    }
  };

  const handleDeleteService = async (serviceId) => {
    // if (!window.confirm('Are you sure you want to delete this service?')) return;

    try {
      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, {
        status: 'deleteService',
        service_id: serviceId
      });
      if (response.data.success) {
        toast.success('Service deleted!', { position: 'top-center' });
        // Filter out from state
        setServices(services.filter((s) => s.id !== serviceId));
      } else {
        toast.error(response.data.error || 'Failed to delete service.', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error while deleting service.', { position: 'top-center' });
    }
  };

  // ----------------------------------
  // G) Fees
  // ----------------------------------
  const handleSaveFees = async (e) => {
    e.preventDefault();
    const bodyData = {
              status: 'saveFees',
              es_builder_estimate_id: singleEst.id,
              job_mark_up: fees.job_mark_up || '',
              sub_mark_up: fees.sub_mark_up || '',
              discount: fees.discount || '',
              tarif_rate: fees.tarif_rate || '', 
              tax_rate: fees.tax_rate || '',
              as_built: fees.as_built || '',
              paf_price: fees.paf_price || '',
              shipping_rate: fees.shipping_rate || ''
            };
            console.log(bodyData, 'bodyData for fees');
            
    try {
      const response = await axios.post(`${apiUrl}/es_builder_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' }
      });
      
      console.log(response.data, 'response for fees');
      
      if (response.data.success) {
        toast.success('Fees saved!', { position: 'top-center' });
      } else {
        toast.error(response.data.error || 'Failed to save fees.', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error while saving fees.', { position: 'top-center' });
    }
  };


  // ----------------------------------
  // RENDER ---
  // ---------------------------------- 
  // Renders the main estimate form
  const renderEstimateForm = () => {
    return (
      <>
      {/* 1) Single Estimate Edit Form */}
      <div className="w-full md:w-1/2 p-5 bg-gray-100 shadow rounded">
        <h2 className="text-lg font-bold mb-2">Edit Estimate (ID: {singleEst.id})</h2>
        <form onSubmit={handleEstimateSubmit} className="space-y-4 mt-4">
          <div>
            <label className="block mb-1 text-gray-700" htmlFor="estimate_type">
              Estimate Type
            </label>
            <input
              id="estimate_type"
              name="estimate_type"
              type="text"
              className="w-full border border-gray-300 rounded px-3 py-2 text-gray-500"
              value={singleEst.estimate_type}
              onChange={handleEstimateChange}
            />
          </div>
          <div>
            <label className="block mb-1 text-gray-700" htmlFor="estimate_name">
              Estimate Name
            </label>
            <input
              id="estimate_name"
              name="estimate_name"
              type="text"
              className="w-full border border-gray-300 rounded px-3 py-2 text-gray-500"
              value={singleEst.estimate_name}
              onChange={handleEstimateChange}
            />
          </div>
          <div>
            <label className="block mb-1 text-gray-700" htmlFor="user_name">
              User Name
            </label>
            <input
              id="user_name"
              name="user_name"
              type="text"
              className="w-full border border-gray-300 rounded px-3 py-2 text-gray-500"
              value={singleEst.user_name}
              onChange={handleEstimateChange}
            />
          </div>
          <div>
            <label className="block mb-1 text-gray-700" htmlFor="full_description">
              Description
            </label>
            <textarea
              id="full_description"
              name="full_description"
              rows="3"
              className="w-full border border-gray-300 rounded px-3 py-2 text-gray-500"
              value={singleEst.full_description}
              onChange={handleEstimateChange}
            />
          </div>
          <div>
            <label className="block mb-1 text-gray-700" htmlFor="type">
              Type
            </label>
            <input
              id="type"
              name="type"
              type="text"
              placeholder='Part & Smarts or Full Install'
              className="w-full border border-gray-300 rounded px-3 py-2 text-gray-500"
              value={singleEst.type}
              onChange={handleEstimateChange}
            />
          </div>
          <div>
            <label className="block mb-1 text-gray-700" htmlFor="Manufacture">
              Manufacture
            </label>
            <input
              id="manufacture"
              name="manufacture"
              type="text"
              placeholder='Honeywell, Siemens...'
              className="w-full border border-gray-300 rounded px-3 py-2 text-gray-500"
              value={singleEst.manufacture}
              onChange={handleEstimateChange}
            />
          </div>

          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white font-semibold rounded"
          >
            Save Estimate
          </button>
        </form>
      </div>
      </>
    );
  };
  // Renders your categories list & "add category" form
  const renderCategories = () => {
    return (
      <div className="p-4 bg-gray-100 shadow rounded mb-4 max-w-[600px]">
        <h2 className="text-lg font-bold mb-2">Equipment Categories</h2>

        {equipmentCategories.map((cat) => (
          <div key={cat.id} className="border-b border-gray-200 mb-4 pb-2">
            <p className="text-gray-800 border-b-2">
              <TrashIcon onClick={(e) => handleDeleteEquipmentCat(e, cat.id) } 
                className="h-5 w-5 text-red-500 inline-block cursor-pointer mr-2" />
              {cat.equipment_category}  
            </p>
          </div>
        ))}

        <form onSubmit={handleCategorySubmit} className="space-y-4 mt-4">
          <div>
            <label className="block mb-1 text-gray-700" htmlFor="category_select">
              New Category
            </label>
            {/* The dropdown */}
            <select
              id="category_select"
              className="w-full border border-gray-300 rounded px-3 py-2 text-gray-500"
              value={selectedCategoryOption}
              onChange={handleCategorySelect}
            >
              <option value="">-- Select a category --</option>
              <option value="Panel">Panel</option>
              <option value="Add-On Panel">Add-On Panel</option>
              <option value="Data Panel">Data Panel</option>
              <option value="Add-On Data Panel">Add-On Data Panel</option>
              <option value="Other">Other (type below)</option>
            </select>
          </div>

          {selectedCategoryOption === 'Other' && (
            <div>
              <label className="block mb-1 text-gray-700" htmlFor="equipment_category">
                New Category
              </label>
              <input
                id="equipment_category"
                name="equipment_category"
                type="text"
                className="w-full border border-gray-300 rounded px-3 py-2 text-gray-500"
                value={newCategory.equipment_category}
                onChange={handleCategoryChange}
                placeholder="Field Devices..."
              />
            </div>
          )}

          <button type="submit" className="px-4 py-2 bg-green-600 text-white font-semibold rounded">
            Add Category
          </button>
        </form>
      </div>
    );
  };
  //render equipment devices
  const renderEquipmentTabs = () => {
    return (
      <>
        <div className="w-full md:w-1/2 p-4 bg-gray-100 shadow rounded float-start">
          <h2 className="text-lg font-bold mb-2">Add New Device</h2>

          <div className="space-y-4 mt-4">
            <div>
              <label className="block mb-1 text-gray-700" htmlFor="categoryId">
                Category
              </label>

              <select
                id="categoryId"
                name="categoryId"
                className="w-full border border-gray-300 rounded px-3 py-2 text-gray-500"
                value={newDevice.categoryId}
                onChange={handleDeviceChange}
              >
                <option value="">Select a category</option>
                {equipmentCategories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.equipment_category}
                  </option>
                ))}
              </select>
            </div>

            <button
              type="button"
              onClick={() => {
                if (!newDevice.categoryId) {
                  toast.error('Please select a category first.', {
                    position: 'top-center',
                  });
                  return;
                }

                setShowDeviceModal(true);
              }}
              className="px-4 py-2 bg-blue-600 text-white font-semibold rounded"
            >
              Search / Add Devices
            </button>
          </div>
        </div>

        <div className="w-full md:w-1/2 p-4 bg-gray-100 shadow rounded float-end">
          <div className="mb-4 space-y-2 space-x-2">
            {equipmentCategories.map((cat) => (
              <button
                key={cat.id}
                onClick={() => handleCatTabClick(cat.id)}
                className={
                  cat.id === activeCategoryId
                    ? 'px-4 py-2 bg-blue-600 text-white font-semibold rounded'
                    : 'px-4 py-2 bg-gray-200 text-gray-800 font-semibold rounded'
                }
              >
                {cat.equipment_category}
              </button>
            ))}
          </div>

          {equipmentCategories.map((cat) => {
            if (cat.id !== activeCategoryId) return null;

            return (
              <div key={cat.id} className="mt-4">
                <DevicesAccordion categoryId={cat.id} />
              </div>
            );
          })}
        </div>
      </>
    );
  };

  useEffect(() => {
    const fetchDeviceResults = async () => {
      if (!showDeviceModal) return;

      if (deviceSearch.trim().length < 3) {
        setDeviceResults([]);
        return;
      }

      try {
        const response = await axios.post(`${apiUrl}/es_builder_crud.php`, {
          data: { search: deviceSearch },
          status: 'search',
        }, {
          headers: { 'Content-Type': 'application/json' },
        });

        setDeviceResults(response.data.search_results || []);
      } catch (error) {
        console.error('Error fetching devices:', error);
        setDeviceResults([]);
      }
    };

    const timeoutId = setTimeout(fetchDeviceResults, 300);
    return () => clearTimeout(timeoutId);
  }, [deviceSearch, showDeviceModal, apiUrl]);

  // Renders Labor
  const renderLabor = () => {
    return (
      <div className="p-4 bg-gray-100 shadow rounded mb-4 max-w-[600px]">
        <h2 className="text-xl font-bold mb-4">Labor Categories</h2>

        {loadingCategories ? (
          <p>Loading labor...</p>
        ) : (
          <>
            <table className="min-w-full divide-y divide-gray-200 border">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-3 py-2 text-left text-sm font-medium text-gray-700">Name</th>
                  <th className="px-3 py-2 text-left text-sm font-medium text-gray-700">Rate</th>
                  <th className="px-3 py-2 text-left text-sm font-medium text-gray-700">Min Hours</th>
                  <th className="px-3 py-2 text-center text-sm font-medium text-gray-700">Active</th>
                  <th className="px-3 py-2 text-center text-sm font-medium text-gray-700"></th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {laborCategories.map((cat, index) => (
                  <tr key={cat.id}>
                    {/* Name */}
                    <td className="px-3 py-2 text-sm text-gray-700">
                      {cat.name}
                    </td>

                    {/* Rate */}
                    <td className="px-3 py-2 text-sm text-gray-700">
                      <input
                        type="number"
                        value={cat.rate}
                        onChange={(e) =>
                          handleCategoryFieldChange(cat.id, 'rate', e.target.value)
                        }
                        className="w-20 rounded-md border-gray-300 shadow-sm
                                  focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </td>

                    {/* Min Hours */}
                    <td className="px-3 py-2 text-sm text-gray-700">
                      <input
                        type="number"
                        value={cat.min_hours}
                        onChange={(e) =>
                          handleCategoryFieldChange(cat.id, 'min_hours', e.target.value)
                        }
                        className="w-20 rounded-md border-gray-300 shadow-sm
                                  focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                      />
                    </td>

                    {/* Active Checkbox */}
                    <td className="px-3 py-2 text-center">
                      <input
                        type="checkbox"
                        checked={cat.is_active === 1 || cat.is_active === true}
                        onChange={(e) =>
                          handleCategoryFieldChange(cat.id, 'is_active', e.target.checked ? 1 : 0)
                        }
                      />
                    </td>

                    {/* Delete Button (for rows after the first 6) */}
                    <td className="px-3 py-2 text-center">
                      {index >= 6 && (
                        <button
                          onClick={() => handleDeleteCat(cat.id)}
                          className="inline-flex items-center justify-center rounded-full
                                    p-2 hover:bg-red-100 text-red-600"
                        >
                          <TrashIcon className="h-4 w-4" aria-hidden="true" />
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Inline form to add a new labor row */}
            <form onSubmit={handleAddLabor} className="mt-4 flex items-end gap-2">
              {/* Name */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700">Name</label>
                <input
                  type="text"
                  className="w-full rounded-md border-gray-300 text-sm"
                  value={newLabor.name}
                  onChange={(e) => setNewLabor({ ...newLabor, name: e.target.value })}
                  required
                />
              </div>

              {/* Rate */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700">Rate</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-20 rounded-md border-gray-300 text-sm"
                  value={newLabor.rate}
                  onChange={(e) => setNewLabor({ ...newLabor, rate: e.target.value })}
                  required
                />
              </div>

              {/* Min Hours */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700">Min Hours</label>
                <input
                  type="number"
                  step="0.01"
                  className="w-20 rounded-md border-gray-300 text-sm"
                  value={newLabor.min_hours}
                  onChange={(e) => setNewLabor({ ...newLabor, min_hours: e.target.value })}
                  required
                />
              </div>

              {/* Active */}
              <div className="flex flex-col">
                <label className="text-sm font-medium text-gray-700">Active</label>
                <select
                  className="rounded-md border-gray-300 text-sm"
                  value={newLabor.is_active}
                  onChange={(e) => setNewLabor({ ...newLabor, is_active: Number(e.target.value) })}
                >
                  <option value={1}>Yes</option>
                  <option value={0}>No</option>
                </select>
              </div>

              <button
                type="submit"
                className="px-4 py-2 bg-green-600 text-white rounded text-sm font-medium"
              >
                Add
              </button>
            </form>

            {/* Save button for updated categories */}
            <button
              type="button"
              onClick={handleSaveCategories}
              className="mt-4 px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
              disabled={savingCategories}
            >
              {savingCategories ? 'Saving...' : 'Save List'}
            </button>
          </>
        )}
      </div>
    );
  };
  // Render Notes
  const renderNotes = () => {
    // 1) Group notes by cat
    const groupedNotes = notes.reduce((acc, note) => {
      if (!acc[note.cat]) {
        acc[note.cat] = [];
      }
      acc[note.cat].push(note);
      return acc;
    }, {});

    return (
      <div className="p-4 bg-white shadow rounded mb-4">
        <h2 className="text-lg font-bold mb-2">Notes</h2>

        {/* Two-column layout */}
        <div className="flex flex-col md:flex-row gap-4">
          {/* Left: Form */}
          <div className="w-full md:w-1/2">
            {/* Form to add a new note */}
            <form onSubmit={handleAddNote} className="space-y-4 mt-4 bg-gray-100 p-4 rounded shadow">
              <div>
                <label className="block mb-1 font-semibold" htmlFor="key_order">
                  Key Order
                </label>
                <input
                  id="key_order"
                  name="key_order"
                  type="number"
                  className="w-20 border border-gray-300 rounded px-3 py-2"
                  value={newNote.key_order}
                  onChange={(e) => setNewNote({ ...newNote, key_order: e.target.value })}
                />
              </div>

              <div>
                <label className="block mb-1 font-semibold" htmlFor="notes">
                  Note
                </label>
                <textarea
                  id="notes"
                  name="notes"
                  rows="2"
                  className="w-full border border-gray-300 rounded px-3 py-2 resize-none"
                  value={newNote.notes}
                  onChange={(e) => setNewNote({ ...newNote, notes: e.target.value })}
                />
              </div>

              <div>
                <label className="block mb-1 font-semibold" htmlFor="cat">
                  Category
                </label>
                <input
                  id="cat"
                  name="cat"
                  type="text"
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  value={newNote.cat}
                  onChange={(e) => setNewNote({ ...newNote, cat: e.target.value })}
                />
              </div>

              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white font-semibold rounded"
              >
                Add Note
              </button>
            </form>
          </div>

          {/* Right: Grouped notes by category */}
          <div className="w-full md:w-1/2">
            {Object.keys(groupedNotes).length === 0 ? (
              <p className="mt-4 text-gray-500">No notes available.</p>
            ) : (
              Object.entries(groupedNotes).map(([cat, catNotes]) => (
                <div key={cat} className="mb-6">
                  <h3 className="font-semibold text-base border-b mb-2 pb-1 bg-blue-200 p-2 rounded">
                    Category: {cat}
                  </h3>
                  {/* List out the notes for this category */}
                  {catNotes.map((note) => (
                    <div
                      key={note.id}
                      className="flex justify-between items-start border-b py-2"
                    >
                      <div className="pr-2">
                        <span className="font-semibold">Order: {note.key_order}</span>
                        <br />
                        <span className='text-gray-500'>{note.notes}</span>
                      </div>
                      {/* Delete button */}
                      <button
                        onClick={() => handleDeleteNote(note.id)}
                        className="text-red-600 hover:text-red-800"
                      >
                        <TrashIcon className="h-5 w-5" />
                      </button>
                    </div>
                  ))}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    );
  };
  //Render Services
  const renderServices = () => {
    // 1) Group services by cat
    const groupedServices = services.reduce((acc, svc) => {
      if (!acc[svc.cat]) acc[svc.cat] = [];
      acc[svc.cat].push(svc);
      return acc;
    }, {});

    return (
      <div className="p-4 bg-white shadow rounded mb-4">
        <h2 className="text-lg font-bold mb-2">Services</h2>

        {/* Two-column layout */}
        <div className="flex flex-col md:flex-row gap-4">
          {/* Left: Service Form */}
          <div className="w-full md:w-1/2">
            <form onSubmit={handleAddService} className="space-y-4 mt-4">
              <div>
                <label className="block mb-1 font-semibold" htmlFor="svcName">
                  Name
                </label>
                <input
                  id="svcName"
                  name="svcName"
                  type="text"
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  value={newService.name}
                  onChange={(e) => setNewService({ ...newService, name: e.target.value })}
                />
              </div>

              <div>
                <label className="block mb-1 font-semibold" htmlFor="svcPrice">
                  Price
                </label>
                <input
                  id="svcPrice"
                  name="svcPrice"
                  type="number"
                  step="0.01"
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  value={newService.price}
                  onChange={(e) => setNewService({ ...newService, price: e.target.value })}
                />
              </div>

              <div>
                <label className="block mb-1 font-semibold" htmlFor="svcCat">
                  Category
                </label>
                <input
                  id="svcCat"
                  name="svcCat"
                  type="text"
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  value={newService.cat}
                  onChange={(e) => setNewService({ ...newService, cat: e.target.value })}
                />
              </div>

              <div>
                <label className="block mb-1 font-semibold" htmlFor="svcActive">
                  Active?
                </label>
                <select
                  id="svcActive"
                  name="svcActive"
                  className="w-full border border-gray-300 rounded px-3 py-2"
                  value={newService.is_active}
                  onChange={(e) => setNewService({ ...newService, is_active: Number(e.target.value) })}
                >
                  <option value={1}>Yes</option>
                  <option value={0}>No</option>
                </select>
              </div>

              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white font-semibold rounded"
              >
                Add
              </button>
            </form>
          </div>

          {/* Right: Grouped Services by Category */}
          <div className="w-full md:w-1/2">
            {Object.keys(groupedServices).length === 0 ? (
              <p className="mt-4 text-gray-500">No services available.</p>
            ) : (
              Object.entries(groupedServices).map(([cat, svcList]) => (
                <div key={cat} className="mb-6">
                  <h3 className="font-semibold text-base border-b mb-2 pb-1 bg-blue-300 p-2 rounded">
                    Category: {cat}
                  </h3>
                  {/* List out the services for this category */}
                  {svcList.map((svc) => (
                    <div key={svc.id} className="flex justify-between items-start border-b py-2" >
                      <div className="pr-2">
                        <span className="font-semibold text-green-700">{svc.name}</span>
                        <br />
                        <span>Price: ${svc.price}</span>
                        <br />
                        <span className="text-xs">
                          {svc.is_active ? 'Active' : 'Inactive'}
                        </span>
                      </div>
                      {/* Delete button */}
                      <button onClick={() => handleDeleteService(svc.id)} className="text-red-600 hover:text-red-800">
                        <TrashIcon className="h-5 w-5" />
                      </button>
                    </div>
                  ))}
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    );
  };
  // Render Fees
  const renderFees = () => {
    return (
      <div className="p-4 bg-white shadow rounded mb-4 max-w-[600px]">
        <h2 className="text-lg font-bold mb-2">Fees</h2>

        <form onSubmit={handleSaveFees} className="space-y-4 mt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Job Mark Up */}
            <div>
              <label className="block mb-1 font-semibold" htmlFor="job_mark_up">
                Job Mark Up (%)
              </label>
              <input
                id="job_mark_up"
                name="job_mark_up"
                type="number"
                className="w-full border border-gray-300 rounded px-3 py-2"
                value={fees.job_mark_up || ''}
                onChange={(e) => setFees({ ...fees, job_mark_up: e.target.value })}
              />
            </div>
            {/* Sub Mark Up */}
            <div>
              <label className="block mb-1 font-semibold" htmlFor="sub_mark_up">
                Sub Mark Up (%)
              </label>
              <input
                id="sub_mark_up"
                name="sub_mark_up"
                type="number"
                className="w-full border border-gray-300 rounded px-3 py-2"
                value={fees.sub_mark_up || ''}
                onChange={(e) => setFees({ ...fees, sub_mark_up: e.target.value })}
              />
            </div>

            {/* Discount */}
            <div>
              <label className="block mb-1 font-semibold" htmlFor="discount">
                Discount (%)
              </label>
              <input
                id="discount"
                name="discount"
                type="number"
                className="w-full border border-gray-300 rounded px-3 py-2"
                value={fees.discount || ''}
                onChange={(e) => setFees({ ...fees, discount: e.target.value })}
              />
            </div>

            {/* Tarif Rate */}
            <div>
              <label className="block mb-1 font-semibold" htmlFor="tarif_rate">
                Tariff Rate (%)
              </label>
              <input
                id="tarif_rate"
                name="tarif_rate"
                type="number"
                step="0.01"
                className="w-full border border-gray-300 rounded px-3 py-2"
                value={fees.tarif_rate || ''}
                onChange={(e) => setFees({ ...fees, tarif_rate: e.target.value })}
              />
            </div>

            {/* Tax Rate */}
            <div>
              <label className="block mb-1 font-semibold" htmlFor="tax_rate">
                Tax Rate (%)
              </label>
              <input
                id="tax_rate"
                name="tax_rate"
                type="number"
                step="0.01"
                className="w-full border border-gray-300 rounded px-3 py-2"
                value={fees.tax_rate || ''}
                onChange={(e) => setFees({ ...fees, tax_rate: e.target.value })}
              />
            </div>

            {/* As Built */}
            <div>
              <label className="block mb-1 font-semibold" htmlFor="as_built">
                As Built ($)
              </label>
              <input
                id="as_built"
                name="as_built"
                type="number"
                step="0.01"
                className="w-full border border-gray-300 rounded px-3 py-2"
                value={fees.as_built || ''}
                onChange={(e) => setFees({ ...fees, as_built: e.target.value })}
              />
            </div>

            {/* shipping_rate */}
            <div>
              <label className="block mb-1 font-semibold" htmlFor="shipping_rate">
                Shipping Rate(%)
              </label>
              <input
                id="shipping_rate"
                name="shipping_rate"
                type="number"
                step="0.01"
                className="w-full border border-gray-300 rounded px-3 py-2"
                value={fees.shipping_rate || ''}
                onChange={(e) => setFees({ ...fees, shipping_rate: e.target.value })}
              />
            </div>

            {/* PAF Price */}
            <div>
              <label className="block mb-1 font-semibold" htmlFor="paf_price">
                Project Authorization Letter Price($)
              </label>
              <input
                id="paf_price"
                name="paf_price"
                type="number"
                step="0.01"
                className="w-full border border-gray-300 rounded px-3 py-2"
                value={fees.paf_price || ''}
                onChange={(e) => setFees({ ...fees, paf_price: e.target.value })}
              />
            </div>
          </div>

          <button
            type="submit"
            className="mt-4 px-4 py-2 bg-blue-600 text-white font-semibold rounded"
          >
            Save Fees
          </button>
        </form>
      </div>
    );
  };


  // ----------------------------------
  // Return the overall component
  // ----------------------------------
  //Render Estimate
  const renderSingleEstimateTabs = () => {
    return (
      <div className="mt-4">
        {/* Tab Buttons */}
        <div className="mb-8 space-x-2">
          <button
            onClick={() => handleTabClick('estimate')}
            className={`px-4 py-2 mr-2 ${
              activeTab === 'estimate' ? 'bg-blue-600 text-white' : 'bg-gray-200'
            }`}
          >
            Estimate
          </button>

          <button
            onClick={() => handleTabClick('categories')}
            className={`px-4 py-2 ${
              activeTab === 'categories' ? 'bg-blue-600 text-white' : 'bg-gray-200'
            }`}
          >
            Add Eq Categories
          </button>

          <button
            onClick={() => handleTabClick('devices')}
            className={`px-4 py-2 ${
              activeTab === 'devices' ? 'bg-blue-600 text-white' : 'bg-gray-200'
            }`}
          >
            Add Eq Devices
          </button>

          <button
            onClick={() => handleTabClick('labor')}
            className={`px-4 py-2 ${
              activeTab === 'labor' ? 'bg-blue-600 text-white' : 'bg-gray-200'
            }`}
          >
            Add Labor
          </button>

          <button
            onClick={() => handleTabClick('notes')}
            className={`px-4 py-2 ${
              activeTab === 'notes' ? 'bg-blue-600 text-white' : 'bg-gray-200'
            }`}
          >
            Add Notes
          </button>

          <button
            onClick={() => handleTabClick('services')}
            className={`px-4 py-2 ${
              activeTab === 'services' ? 'bg-blue-600 text-white' : 'bg-gray-200'
            }`}
          >
            Add Services
          </button>

          <button
            onClick={() => handleTabClick('fees')}
            className={`px-4 py-2 ${
              activeTab === 'fees' ? 'bg-blue-600 text-white' : 'bg-gray-200'
            }`}
          >
            Fees
          </button>

        </div>

        {/* Tab Content */}
        {activeTab === 'estimate' && renderEstimateForm()}
        {activeTab === 'categories' && renderCategories()}
        {activeTab === 'devices' && renderEquipmentTabs()}
        {activeTab === 'labor' && renderLabor()}
        {activeTab === 'notes' && renderNotes()}
        {activeTab === 'services' && renderServices()}
        {activeTab === 'fees' && renderFees()}
      </div>
    );
  };
  //-----------------------------------

  const handleBatchAddDevices = async () => {
    if (!newDevice.categoryId) {
      toast.error('Please select a category.', { position: 'top-center' });
      return;
    }

    if (selectedDeviceIds.length === 0) {
      toast.error('Please select at least one device.', { position: 'top-center' });
      return;
    }

    setSavingDevices(true);

    try {
      const requests = selectedDeviceIds.map((equipmentId) =>
        axios.post(
          `${apiUrl}/es_builder_crud.php`,
          {
            status: 'esBuilderAddDevice',
            es_builder_equipment_cat_id: newDevice.categoryId,
            equipment_list_id: equipmentId,
          },
          {
            headers: { 'Content-Type': 'application/json' },
          }
        )
      );

      const responses = await Promise.all(requests);

      const hasError = responses.some((res) => !res.data.success);

      if (hasError) {
        toast.error('Some devices failed to add.', { position: 'top-center' });
      } else {
        toast.success('Devices added successfully!', { position: 'top-center' });
      }

      setSelectedDeviceIds([]);
      setDeviceSearch('');
      setDeviceResults([]);
      setShowDeviceModal(false);

      fetchData(singleEst.id);
    } catch (error) {
      toast.error('Error while adding devices.', { position: 'top-center' });
    } finally {
      setSavingDevices(false);
    }
  };

  return (
    <div className="mx-auto max-w-[1200px] px-4 sm:px-6 lg:px-8 py-8 bg-white">
      <HeadingCp label="Template Builder" />
      {loading && <p>Loading...</p>}
      {isListMode ? ( renderAllEstimates() ) : 
      (
        <>
          <div className="flex mb-4">
            <a href='/es_builder/list' 
                className="px-4 py-2
                         text-blue-700 font-semibold rounded 
                         hover:text-blue-400 underline">
                          Template List
            </a>
            <a href='/equipment_list' 
                className="px-4 py-2
                         text-green-700 font-semibold rounded 
                         hover:text-blue-400 underline">
                          Equipment Library
            </a>
          </div>

          {renderSingleEstimateTabs()}
        </>
      )}
      {showCreateModal && (
        <>
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-6 rounded shadow-lg md:w-1/2 w-full">
          {/* A close button */}
          <button
            className="text-gray-500 mb-2 float-right"
            onClick={() => setShowCreateModal(false)}
          >
            X
          </button>

          {/* Render the estimate form you already have, 
              but it will be for a "new" estimate */}
          <div className="">
            <h2 className="text-lg font-bold mb-2">
              {singleEst.id ? 'Edit' : 'Create New'} Template
            </h2>
            <form onSubmit={handleEstimateSubmit} className="space-y-4 mt-4">
              <div>
                <label className="block mb-1 text-gray-700" htmlFor="estimate_name">
                  Estimate Name
                </label>
                <input
                  id="estimate_name"
                  name="estimate_name"
                  type="text"
                  required
                  className="w-full border border-gray-300 rounded px-3 py-2 text-gray-500"
                  value={singleEst.estimate_name}
                  onChange={handleEstimateChange}
                />
              </div>

              <div>
                <label className="block mb-1 text-gray-700" htmlFor="full_description">
                  Description
                </label>
                <textarea
                  id="full_description"
                  name="full_description"
                  rows="3"
                  className="w-full border border-gray-300 rounded px-3 py-2 text-gray-500"
                  value={singleEst.full_description}
                  onChange={handleEstimateChange}
                />
              </div>
              <div>
                <label className="block mb-1 text-gray-700" htmlFor="type">
                  Type
                </label>
                <input
                  id="type"
                  name="type"
                  type="text"
                  required
                  className="w-full border border-gray-300 rounded px-3 py-2 text-gray-500"
                  value={singleEst.type}
                  onChange={handleEstimateChange}
                />
              </div>
              <div>
                <label className="block mb-1 text-gray-700" htmlFor="manufacture">
                  Manufacturer
                </label>
                <input
                  id="manufacture"
                  name="manufacture"
                  type="text"
                  required
                  className="w-full border border-gray-300 rounded px-3 py-2 mb-2 text-gray-500"
                  value={singleEst.manufacture}
                  onChange={handleEstimateChange}
                />
              </div>

              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 text-white font-semibold rounded"
              >
                Save Estimate
              </button>
            </form>
          </div>
        </div>
       </div>       
        </>
      )}

      {/* Confirmation Modal */}
      {showConfirmModal && deleteTemplate && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen text-center">
            {/* Background overlay */}
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            {/* Modal panel */}
            <div
              className="inline-block bg-white rounded-lg text-left 
              overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div>
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Confirm Deletion
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Are you sure you want to delete template: {' '}
                      <strong>
                        {deleteTemplate.estimate_name} by {deleteTemplate.user_name}
                      </strong>
                      ? This action cannot be undone.
                    </p>
                  </div>
                </div>
              </div>

              {/* Modal actions */}
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse">
                <button
                  onClick={handleDeleteTemplate}
                  className="w-full inline-flex justify-center rounded-md border border-transparent 
                  shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Delete
                </button>

                <button
                  onClick={cancelDelete}
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 
                  shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}      

      {/* issues Modal */}
      {showIssuesModal && activeEstimate && (
        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen text-center">
            {/* Background overlay */}
            <div className="fixed inset-0 transition-opacity" aria-hidden="true">
              <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
            </div>
            {/* Modal panel */}
            <div
              className="inline-block bg-white rounded-lg text-left 
              overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div>
                  <h3 className="text-lg leading-6 font-medium text-gray-900">
                    Active Estimate(s)
                  </h3>
                  <div className="mt-2">
                    <div className="text-sm text-gray-500">
                     {activeEstimate.map((est) => (
                      <>
                      <div key={est.id} className="flex justify-between items-start border-b py-2">
                        <div className="pr-2">
                          <span className="font-semibold">
                           ID: {est.id} | {est.bidding_address} | {est.date}
                          </span>
                        </div>
                      </div>
                      </>
                     ))}
                      <span className='text-red-800'> You need to delete all active estimate(s) 
                        in order to delete this template
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Modal actions */}
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse">
                <button
                  onClick={okIssues}
                  className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 
                  shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      )}      

      {showDeviceModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white rounded shadow-lg w-full max-w-3xl p-6">
            <button
              className="float-right text-gray-600"
              onClick={() => setShowDeviceModal(false)}
            >
              X
            </button>

            <h2 className="text-lg font-bold mb-4">Add Devices</h2>

            <input
              type="text"
              value={deviceSearch}
              onChange={(e) => setDeviceSearch(e.target.value)}
              placeholder="Search smoke detector, horn, module..."
              className="w-full border border-gray-300 rounded px-3 py-2 mb-4"
            />

            <div className="max-h-[400px] overflow-y-auto border rounded">
              {deviceResults.map((device) => (
                <label
                  key={device.id}
                  className="flex items-start gap-3 p-3 border-b hover:bg-gray-50 cursor-pointer"
                >
                  <input
                    type="checkbox"
                    checked={selectedDeviceIds.includes(device.id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedDeviceIds((prev) => [...prev, device.id]);
                      } else {
                        setSelectedDeviceIds((prev) =>
                          prev.filter((id) => id !== device.id)
                        );
                      }
                    }}
                  />

                  <div>
                    <p className="font-semibold">{device.part}</p>
                    <p className="text-sm text-gray-500">{device.description}</p>
                    <p className="text-xs text-gray-400">{device.sub_category}</p>
                  </div>
                </label>
              ))}
            </div>

            <div className="flex justify-end gap-2 mt-4">
              <button
                type="button"
                onClick={() => setShowDeviceModal(false)}
                className="px-4 py-2 bg-gray-200 rounded"
              >
                Cancel
              </button>

              <button
                type="button"
                onClick={handleBatchAddDevices}
                className="px-4 py-2 bg-blue-600 text-white rounded"
              >
                Add Selected
              </button>
            </div>
          </div>
        </div>
      )}      
    </div>  
  );
};

export default EsBuilder;
